import React from 'react'
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box } from '@mui/material';

const ZoomControl = ({ handleZoomIn = () => { }, handleZoomOut = () => { } }) => {
    return (
        <Box sx={{ position: 'absolute', top: 10, right: 20, zIndex: 10 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#ffffff',
                    borderRadius: 1,
                    boxShadow: 3,
                    overflow: 'hidden',
                    border: '1px solid #e0e0e0',
                }}
            >
                <Box
                    onClick={handleZoomIn}
                    sx={{
                        p: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s',
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                        },
                    }}
                >
                    <AddIcon fontSize="small" />
                </Box>
                <Box
                    onClick={handleZoomOut}
                    sx={{
                        p: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s',
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                        },
                    }}
                >
                    <RemoveIcon fontSize="small" />
                </Box>
            </Box>
        </Box>
    )
}

export default ZoomControl